import React from 'react';

interface StructuredDataProps {
  /**
   * Single schema object or array of schema objects to render as JSON-LD
   */
  data: object | object[];
}

function serializeStructuredData(schema: object): string {
  return JSON.stringify(schema).replace(/</g, '\\u003c').replace(/>/g, '\\u003e');
}

/**
 * Renders JSON-LD in the document so prerender/SSR and "view source" include schema.
 * Client navigations update these nodes via normal React reconciliation (no useEffect).
 */
const StructuredData: React.FC<StructuredDataProps> = ({ data }) => {
  const schemas = Array.isArray(data) ? data : [data];

  return (
    <>
      {schemas.map((schema, index) => (
        <script
          key={index}
          type="application/ld+json"
          data-structured-data-script="true"
          data-schema-index={String(index)}
          dangerouslySetInnerHTML={{ __html: serializeStructuredData(schema) }}
        />
      ))}
    </>
  );
};

export default StructuredData;
